import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import { CaretIcon } from './CaretIcon';

export function MobileNavLink({ name = "", path = null, subNavigation = [] }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(prev => !prev);

    const handleNavLinkClick = () => {
        document.getElementById('side-panel-button')?.click();
        setIsOpen(false);
    };

    const hasSub = subNavigation.length > 0;

    return (
        <div className="group">

            {/* CASE 1: Item with SUBNAVIGATION ➝ Use BUTTON */}
            {hasSub ? (
                <button
                    onClick={toggle}
                    className={`flex justify-between items-center w-full -mx-3 rounded-lg px-3 py-2 text-base font-semibold text-white 
                    hover:text-gray-400 hover:bg-white/5 transform duration-300 transition-colors
                    ${isOpen ? 'bg-white/10' : ""}`}
                >
                    {name}
                    <CaretIcon
                        isOpen={isOpen}
                        className={`w-5 h-5 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    />
                </button>
            ) : (
                /* CASE 2: Item without subnav ➝ Use NAVLINK */
                <NavLink
                    to={path}
                    onClick={handleNavLinkClick}
                    className={({ isActive }) =>
                        `block w-full -mx-3 px-3 py-2 rounded-lg text-base font-semibold
                         text-white hover:!text-gray-400 hover:bg-white/5 transform duration-300 transition-colors
                         ${isActive ? 'bg-white/10' : ""}`
                    }
                >
                    {name}
                </NavLink>
            )}

            {/* SUBMENU */}
            {hasSub && (
                <div
                    className={`flex flex-col pl-6 space-y-1 mt-2 border-l border-white/30 
                    overflow-hidden transition-all duration-500 ease-in-out
                    ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
                >
                    {subNavigation.map((subItem, idx) => (
                        <NavLink
                            key={idx}
                            to={subItem.path}
                            onClick={handleNavLinkClick}
                            className={({ isActive }) =>
                                `block rounded-lg px-3 py-2 text-sm font-medium text-white/80
                                 hover:!text-gray-400 hover:bg-white/5 transition-colors
                                 ${isActive ? 'bg-white/10 font-semibold' : ''}`
                            }
                        >
                            {subItem.name}
                        </NavLink>
                    ))}
                </div>
            )}

        </div>
    );
}
